import React from "react";
import styled from "styled-components/macro";
import { Outlet, Navigate } from "react-router-dom";
import useAuthStore from "@/store/useAuthStore";

const Root = styled.div`
  min-height: 100vh;
  background-color: ${(props) => props.theme.palette.background.main};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Auth = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isAuthenticating = useAuthStore((state) => state.isAuthenticating);

  if (isAuthenticated && !isAuthenticating) {
    return <Navigate to="/" />;
  }

  return (
    <Root>
      <Outlet />
    </Root>
  );
};

export default Auth;
